import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
  EditorState,
  EditorBlock,
  ContentBlock,
  DefaultDraftBlockRenderMap,
  genKey
} from 'draft-js'
import { List, Map } from 'immutable'
import { stateToHTML } from 'draft-js-export-html'
import { stateFromHTML } from 'draft-js-import-html'
import { Editor as DraftEditor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

// component

const TOOLBAR_OPTIONS = {
  options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link'],
  inline: {
    inDropdown: false,
    options: ['bold', 'italic', 'underline', 'strikethrough']
  },
  blockType: {
    inDropdown: true,
  },
  fontSize: {
    options: [12, 14, 16, 18, 24, 30, 36, 48]
  },
  list: {
    options: ['unordered', 'ordered']
  },
  textAlign: {
    options: ['left', 'center', 'right', 'justify']
  },
  colorPicker: {
    colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
      'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
      'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
      'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
      'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
      'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)']
  },
  link: {
    options: ['link']
  }
}

export const convertToHtml = (editorState) => {
  const options = {
    defaultBlockTag: 'p',
    inlineStyles: {
      BOLD: {
        element: 'b'
      },
      ITALIC: {
        element: 'i',
        attributes: {
          class: 'ahihi'
        },
        style: {
          fontSize: 40
        }
      }
    },
    blockRenderers: {
      MyCustomBlock: (block) => {
        return `<div>${block.getText()}</div>`
      }
    }
  }
  const editorSourceHTML = stateToHTML(editorState.getCurrentContent(), options)

  return editorSourceHTML
}

export const convertToDraftJs = (html) => {
  const contentState = stateFromHTML(html)
  const editorState = EditorState.createWithContent(contentState)

  return editorState
}

class Editor extends PureComponent {


  _handleChange = (editorState) => {
    this.props.onReceiveEditorState(editorState)
  }

  _onAddCustomBlock() {
    const selection = this.props.editorState.getSelection()

    this._handleChange(addNewBlockAt(
      this.props.editorState,
      selection.getAnchorKey(),
      'MyCustomBlock'
    ))
  }

  render() {
    const { label, labelClassName, ...other } = this.props

    return (
      <>
        <DraftEditor
          blockRenderMap={extendedBlockRenderMap}
          blockRendererFn={blockRendererFn}
          wrapperClassName="editor"
          toolbarClassName="editor__toolbar"
          editorClassName="editor__body"
          toolbar={TOOLBAR_OPTIONS}
          // toolbarCustomButtons={[
          //   <Ahihi />
          // ]}
          {...other}
        />
        {/* <button onClick={() => this._onAddCustomBlock()}>
          ADD CUSTOM BLOCK
        </button> */}
      </>
    )
  }
}

class MyCustomBlock extends React.Component {
  render() {
    return (
      <div className="my-custom-block">
        <h1
          contentEditable={false}
          readOnly
        >
          Not editable title
        </h1>
        <div className="editable-area">
          <EditorBlock {...this.props} />
        </div>
      </div>
    )
  }
}

function blockRendererFn(contentBlock) {
  const type = contentBlock.getType()

  if (type === 'MyCustomBlock') {
    return {
      component: MyCustomBlock,
      props: {}
    }
  }
}

const RenderMap = new Map({
  MyCustomBlock: {
    element: 'section',
  }
}).merge(DefaultDraftBlockRenderMap)

const extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(RenderMap)

function addNewBlockAt(editorState, pivotBlockKey, newBlockType = 'unstyled', initialData = new Map({})) {
  const content = editorState.getCurrentContent()
  const blockMap = content.getBlockMap()
  const block = blockMap.get(pivotBlockKey)

  if (!block) {
    throw new Error(`The pivot key - ${pivotBlockKey} is not present in blockMap.`)
  }

  const blocksBefore = blockMap.toSeq().takeUntil((v) => (v === block))
  const blocksAfter = blockMap.toSeq().skipUntil((v) => (v === block)).rest()
  const newBlockKey = genKey()

  const newBlock = new ContentBlock({
    key: newBlockKey,
    type: newBlockType,
    text: '',
    characterList: new List(),
    depth: 0,
    data: initialData,
  })

  const newBlockMap = blocksBefore.concat(
    [[pivotBlockKey, block], [newBlockKey, newBlock]],
    blocksAfter
  ).toOrderedMap()

  const selection = editorState.getSelection()

  const newContent = content.merge({
    blockMap: newBlockMap,
    selectionBefore: selection,
    selectionAfter: selection.merge({
      anchorKey: newBlockKey,
      anchorOffset: 0,
      focusKey: newBlockKey,
      focusOffset: 0,
      isBackward: false,
    }),
  })

  return EditorState.push(editorState, newContent, 'split-block')
}

// class Ahihi extends PureComponent {
//   addStar() {
//     const { editorState, onChange } = this.props
//     const contentState = Modifier.replaceText(
//       editorState.getCurrentContent(),
//       editorState.getSelection(),
//       '⭐',
//       editorState.getCurrentInlineStyle(),
//     )
//     onChange(EditorState.push(editorState, contentState, 'insert-characters'))
//   }

//   render() {
//     return (
//       <div onClick={() => this.addStar()}>⭐</div>
//     )
//   }
// }

Editor.propTypes = {
  label: PropTypes.string,
  labelClassName: PropTypes.string
}

export default Editor